import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Hero from "./components/Hero";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import VirtualTour from "./pages/VirtualTour";
import WhatsAppButton from "./components/WhatsAppButton";

// Property Pages
import EzrahAvenue from "./pages/EzrahAvenue";
import LuxeHeights from "./pages/LuxeHeights";
import TheHaven from "./pages/TheHaven";
import HowToBuy from "./pages/HowToBuy";

import "./i18n";

function App() {
  return (
    <div>
      <Header />

      <Routes>
        {/* Home with Hero */}
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Home />
            </>
          }
        />

        {/* Standard Pages */}
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/virtual-tour" element={<VirtualTour />} />

        {/* Property Pages */}
        <Route path="/ezrah-avenue" element={<EzrahAvenue />} />
        <Route path="/luxe-heights" element={<LuxeHeights />} />
        <Route path="/the-haven" element={<TheHaven />} />
        <Route path="/how-to-buy" element={<HowToBuy />} />
      </Routes>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
